const palette = {
  background: {
    default: "#f3f6f8"
  },
  primary: {
    dark: "#0d332e",
    main: "#134C45",
    light: "#197f6c"
  },
  secondary: {
    dark: "#000",
    main: "#333",
    light: "#929191"
  },
  warning: {
    light: "#F6D89C",
    main: "#E9B550",
    dark: "#CE9423"
  },
  error: {
    light: "#EF8E80",
    main: "#D5351F",
    dark: "#A71805"
  }
};

export default palette;
